import React from 'react';
import './RadioGroup.style.css';
import radio_unchecked from 'assets/radio_unchecked.svg';
import radio_checked from 'assets/radio_checked.svg';
import { stringToMoneyFormat } from 'utils';

const RadioGroup = (props) => {
  /* ===== Route ===== */
  /* ===== Props ===== */
  const { items = [], value, onChange, isCostShow = false } = props;

  /* ===== State ===== */
  /* ===== Hooks ===== */
  /* ===== Function ===== */
  /* ===== Variable ===== */
  /* ===== Hooks ===== */
  /* ===== Render ===== */
  if (!items.length) return;

  return (
    <ul className="radio-group-wrap">
      {items.map((item, index) => (
        <li
          key={`radio-item-${index}`}
          className="radio-group-item"
          onClick={() => onChange(item)}
        >
          <p>{item.option_name}</p>

          <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
            {isCostShow ? (
              <p style={{ color: '#BDBDBD', fontSize: 12, lineHeight: 1 }}>
                (+ {stringToMoneyFormat(item?.option_price, '원')})
              </p>
            ) : (
              ''
            )}
            <img
              src={item.option_key === value ? radio_checked : radio_unchecked}
              alt="radio"
              width={18}
              height={18}
            />
          </div>
        </li>
      ))}
    </ul>
  );
};

export default RadioGroup;
